module.exports = __webpack_public_path__ + "static/media/joseph-stalin_.24662eac.jpg";